//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

//local imports
import { AbstractCategoryModel } from '@app/catalog-common';
import { Transforms } from '@app/shared';

@Component({
    selector: 'category-selection-list',
    templateUrl: './category-selection-list.component.html',
    styleUrl: './category-selection-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategorySelectionListComponent {

    public categories = input.required<AbstractCategoryModel[]>();
    public id = input.required<string>();
    public formGroup = input.required<FormGroup>();
    public label = input<string>("Category");
    public required = input(false, {
        transform: Transforms.toBoolean
      });
}
